module.exports = __webpack_public_path__ + "static/media/digitalization.c22bce59.svg";